<template>
  <div>

    <div class="CertificateAuthorization" id="CertificateAuthorization">
      <!-- <img src="@/assets/channel/leftCertifAut.png" alt="" class="right" @click="rightClick"> -->
      <div class="context">
        <div>
          <img src="@/assets/channel/YL.png" alt="归创通桥" style="width: 116.25px;height: 52px;margin: 24px;">
        </div>
        <div class="rightTop">
          珠海通桥医疗科技有限公司
        </div>
        <div class="rightTopEnglish">
          Zylox-Tonbridge Medical Technology Co.,Ltd
        </div>
        <div class="line"></div>
        <div class="rightTopCode">
          编号：{{GCYLList.AuthorityCode}}
        </div>
        <div class="rightTopTitle">
          授权证明书
        </div>
        <div class="contextTop1">
          兹授权<span class="fontRed">{{ GCYLList.ProviderName }}</span>(以下简称“授权经销商”)为珠海通桥医疗科技有限公司(以下简称“通桥医疗”)的指定经销商，
          负责在下列经销区域/医院销售通桥医疗的产品：
          <p class="contextListText-p">
            {{ GCYLList.ListInvName.join('、') }}
          </p>

          通桥医疗对授权经销商依照其经销合同销售的上述产品提供产品质量保证，承诺对授权经销商在以下地区
          所售出的上述产品提供售后服务和技术支持
        </div>
        <div class="contextTop2">
          <div>
            经销区域或医院：
          </div>
          <div class="hospital">
            {{ GCYLList.ListHPName.join('、') }}
          </div>
        </div>
        <div class="contextTop3">
          本授权证明书的有效期为<span class="fontRed">{{ GCYLList.StartDate == null ? '' : GCYLList.StartDate.substring(0,10) }}
          </span>至<span class="fontRed">{{ GCYLList.EndDate == null ? '' : GCYLList.EndDate.substring(0,10) }} </span>，
          自本授权证明书生效之日起任何针
          对上述区域、产品做出的原授权证明书立即自动终止。本公司同时保留在本授权证明书有效期内对授权经销商的
          经销区域、产品做出调整的权利。
        </div>
        <div class="contextTop4">
          特此证明！
        </div>
        <div class="contextTop5">
          (对于非由通桥医疗授权经销商经销的产品，其产品质量保证、售后服务和技术支持与通桥医疗无关，通桥
          医疗概不负责提供产品质量保证、售后服务和技术支持。授权经销商应完全具有上述授权医疗器械产品的国家要
          求所必备的各种有效的资质证照，同时保证其经营活动符合相关法律法规且无违反任何执照、批准、资质或备案
          的限制，否则本授权证明书自动失效。）
        </div>
        <div class="contextTop6">
          珠海通桥医疗科技有限公司
        </div>
        <div class="contextTop7">
          {{ GCYLList.VerifyTime == null ? '' : GCYLList.VerifyTime.substring(0,10) }}
        </div>
        <div class="contextTop8">
          <div class="Top">
            Unit 1-B, Building 4, Zhuhai CEC High-Tech Industrial Park, No. 1, 7th Science and Technology Road, Tangjiawan Town,
          </div>
          <div class="Centers">
            Xiangzhou District, Zhuhai, Guangdong, China
          </div>
          <div class="Bottom">
            珠海市香洲区唐家湾镇科技七路1号珠海中电高科技产业园4栋1-B单元；TEL：0756-3313003
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="download">
        <Btn btnType="btn" backgroundColor="#FFFFFF" width="64px" height="32px" title="下载" color="#666666" border="1px solid #E5E5E5" @btnclick="download(GCYLDATA)"></Btn>
      </div>
      <div class="Print">
        <Btn btnType="btn" backgroundColor="#E71D43" width="64px" height="32px" title="打印" color="#FFFFFF" border="1px solid #E5E5E5" @btnclick="Print(GCYLDATA)"></Btn>
      </div>
    </div>
  </div>

</template>

<script>
import Btn from '../../../../../../../../components/common-btn.vue'
import printAll from '../../../../../../../../common/Print'
export default {
  components: { Btn },
  props: {
    GCYLDATA: {
      type: Object
    }
  },
  data() {
    return {
      GCYLList: null,
      printObj: {
        id: "CertificateAuthorization", //打印页面的id
        popTitle: '', //打印的标题
        preview: false,
        //打印成功后的回调
        endCallback(e) {
          console.log(e, 'e');
        },
        beforeOpenCallback(vue) {
          console.log('打开之前')
        },
        closeCallback(vue) {
          console.log('关闭了打印工具', this.btn, vue)
        }
      }
    }
  },
  created() { },
  mounted() {

  },
  activated() { },
  updated() { },
  methods: {
    rightClick() {
      this.$emit('rightClick')
    },
    download(GCYLDATA) {
      this.$emit('download', GCYLDATA)
    },
    Print(GCYLDATA) {
      this.$emit('Print', GCYLDATA)
    }
  },
  computed: {},
  watch: {
    GCYLDATA: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.GCYLList = newVal
        }
      },
      deep: true,
      immediate: true
    }
  },
}
</script>
<style scoped lang='less'>
.Print {
  display: inline-block;
  margin-left: -10px;
}
.download {
  display: inline-block;
  margin-left: 750px;
  margin-top: 20px;
}
.fontRed {
  color: #e71d43;
}
.right {
  width: 48px;
  height: 48px;
  position: absolute;
  right: 915px;
  top: 440px;
  transform: rotate(180deg);
  cursor: pointer;
}
.CertificateAuthorization {
  width: 100%;
  height: 100%;

  .context {
    width: 800px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.10000000149011612);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin: 0 auto;
    position: relative;
    padding: 0px 20px 0 20px;

    .line {
      width: 805px;
      height: 1px;
      background-color: #333333;
      margin-left: 0px;
    }

    .rightTop {
      margin-top: -80px;
      float: right;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
    .rightTopEnglish {
      margin-top: -50px;
      float: right;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }

    .rightTopCode {
      margin-top: 0px;
      float: right;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }

    .rightTopTitle {
      position: absolute;
      top: 162px;
      left: 340px;
      font-size: 24px;
      font-weight: normal;
      color: #333333;
    }
    .contextTop1 {
      width: 800px;
      height: 112px;
      position: absolute;
      top: 220px;
      left: 24px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      text-indent: 2em;
      line-height: 25px;

      .contextListText-p {
        font-weight: bold;
      }
    }

    .contextTop2 {
      width: 780px;
      position: relative;
      top: 245px;
      left: 43px;
      font-size: 14px;
      margin-left: -10px;
      font-weight: normal;
      color: #333333;
      line-height: 25px;

      .hospital {
        height: 100%;
        margin-top: 10px;
        font-weight: bold;
      }
    }
    .contextTop3 {
      width: 800px;
      height: 112px;
      position: relative;
      top: 276px;
      left: 13px;
      margin-left: -10px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      text-indent: 2em;
      text-indent: 2em;
      line-height: 25px;
    }
    .contextTop4 {
      position: relative;
      top: 250px;
      left: 34px;
      margin-left: -10px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      text-indent: 2em;
    }
    .contextTop5 {
      width: 800px;
      height: 112px;
      position: relative;
      top: 300px;
      left: 28px;
      margin-left: -10px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      text-indent: 2em;
      line-height: 25px;
    }

    .contextTop6 {
      position: relative;
      top: 330px;
      left: 620px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }
    .contextTop7 {
      position: relative;
      top: 350px;
      left: 670px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }
    .contextTop8 {
      position: relative;
      margin-top: 450px;
      font-size: 10px;
      font-weight: normal;
      color: #333333;
      line-height: 20px;

      .Top {
        text-align: center;
      }

      .Centers {
        text-align: center;
      }
      .Bottom {
        text-align: center;
      }
    }
  }
}
</style>